import EditableNode from './nodes/EditableNode';
import ConditionalNode from './nodes/conditionalNode';
import FixedNode from './nodes/FixedNode';
import IfNode from './nodes/IfNode';
import InitializeCameraNode from './nodes/InitializeCameraNode';

// API base URL supports both local and Azure modes.
// Priority:
// 1) REACT_APP_API_BASE_URL (explicit full URL)
// 2) Mode from URL query ?api=local|azure|auto
// 3) Mode from REACT_APP_API_MODE=local|azure|auto (default: auto)
const LOCAL_API_BASE_URL = process.env.REACT_APP_LOCAL_API_BASE_URL || 'http://localhost:3001';
const AZURE_API_BASE_URL =
  process.env.REACT_APP_AZURE_API_BASE_URL ||
  'https://origamirobotics-bvh9cmhqbzfkeebc.eastus-01.azurewebsites.net';

const isLocalHost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const queryApiMode =
  typeof window !== 'undefined'
    ? (new URLSearchParams(window.location.search).get('api') || '').toLowerCase()
    : '';

const envApiMode = (process.env.REACT_APP_API_MODE || 'auto').toLowerCase();
const selectedApiMode = queryApiMode || envApiMode;

const resolveApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (selectedApiMode === 'local') {
    return LOCAL_API_BASE_URL;
  }

  if (selectedApiMode === 'azure') {
    return AZURE_API_BASE_URL;
  }

  // auto mode: local on localhost, Azure elsewhere
  return isLocalHost ? LOCAL_API_BASE_URL : AZURE_API_BASE_URL;
};

export const API_BASE_URL = resolveApiBaseUrl();

export const SKILL_OPTIONS = [
  'camera_skill',
  'detection_skill',
  'navigation_skill',
  'manipulation_skill',
];
export const DEFAULT_SKILL = 'detection_skill';
export const DEFAULT_XML = `<?xml version="1.0" encoding="UTF-8"?>
<root main_tree_to_execute="TaskTree">
  <BehaviorTree ID="TaskTree">
    <Sequence name="MainSequence">
    </Sequence>
  </BehaviorTree>
</root>`;

// Card styling constants
export const CARD_BG = '#24303d';
export const CARD_BORDER_SELECTED = '2px solid #007acc';
export const CARD_BORDER = '1px solid #777';
export const CARD_RADIUS = 10;
export const CARD_TEXT = '#fff';
export const SECTION_BG = '#22303f';
export const SECTION_BORDER = '1px solid #3b4b5d';

export const selStyle = {
  background: '#1f2630',
  color: 'white',
  border: '1px solid #444',
  borderRadius: 6,
  padding: '4px 6px',
};

export const inputStyle = {
  background: '#1f2630',
  color: 'white',
  border: '1px solid #444',
  borderRadius: 6,
  padding: '6px 8px',
  width: '100%',
};

export const nodeTypes = {
  editable: EditableNode,
  conditional: ConditionalNode,
  fixed: FixedNode,
  if: IfNode,
  initCamera: InitializeCameraNode,
};

// ----------------- initial graph -----------------

export const initialNodes = [
  {
    id: 'start',
    type: 'fixed',
    position: { x: 250, y: -100 },
    data: { label: 'Start', color: '#4caf50' },
    draggable: true,
    connectable: true,
  },
  {
    id: 'finish',
    type: 'fixed',
    position: { x: 250, y: 600 },
    data: { label: 'Finish', color: '#f44336' },
    draggable: true,
    connectable: true,
  },
];
